import { CategoryProcessor } from "./CategoryProcessor";
export class CategoryThreeProcessor extends CategoryProcessor {
    getCategory() {
        return 'three';
    }
}
